import axios from 'axios';
import { ADMIN_SERVER, PHOTO_SERVER, SERVER, COLORS } from 'constants/constant';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box, Card, CardContent, Avatar, Typography, Grid, Divider,
    Icon, AppBar, Toolbar, IconButton, ListItemText,
    Switch
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import moment from 'moment';
import MDTypography from 'components/MDTypography';
import AptaTable from 'examples/AptaTable';
import Swal from 'sweetalert2';
import { SERVER_URL } from 'constants/constant';

const Dashboard = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        fetchUser();
    }, []);

    const fetchUser = async () => {
        try {
            const res = await axios.get(`https://api.iria2026.com/api/iria/user/me/${userId}`);
            setUser(res.data?.user);
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
    };

    const handlePaymentToggle = async (data, currentStatus) => {
        try {
            const newStatus = !currentStatus ? "paid" : "unpaid"; // Toggle status
            const response = await axios.put(`${SERVER_URL}/user/update-payment-status/additional-people/${userId}/${data?._id}`, { paymentStatus: newStatus });

            if (response.status === 200) {
                Swal.fire("Success!", "Payment status updated.", "success");
                fetchUser();
            } else {
                Swal.fire("Error!", "Failed to update payment status.", "error");
            }
        } catch (error) {
            Swal.fire("Error!", "Could not update payment status.", "error");
            console.error("Payment update error:", error);
        }
    };
    return (
        <DashboardLayout>
            <AppBar position="sticky">
                <Toolbar style={{ backgroundColor: COLORS.primary, borderRadius: 10, marginBottom: 20 }}>
                    <IconButton edge="start" color="white"
                        // onClick={() => navigate(-1)}
                        onClick={() => navigate(-1, { replace: true })}

                        aria-label="back">
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" style={{ flexGrow: 1, color: "white" }}>
                        User Details
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box sx={{ backgroundColor: '#f9f9f9', minHeight: '100vh', padding: 3 }}>
                {user && (
                    <>
                        <Card sx={{ marginBottom: 4, borderRadius: 3 }}>
                            <CardContent>
                                <Box display="flex" alignItems="center">
                                    <Avatar
                                        src={user.profilePic ? `${PHOTO_SERVER}${user.profilePic}` : undefined}
                                        alt={user.firstName}
                                        sx={{ width: 100, height: 100, marginRight: 3 }}
                                    >
                                        <Icon color="inherit" fontSize="large">account_box</Icon>
                                    </Avatar>
                                    <Box>
                                        <Typography variant="h5" fontWeight="bold">{user.salutation} {user.firstName} {user.lastName}</Typography>
                                        <Typography variant="body2" color="text.secondary"><strong>EMAIL:</strong>{user.email}</Typography>
                                        <Typography variant="body2" color="text.secondary"><strong>REGISTRATION ID:</strong> {user.userId}</Typography>
                                        <Typography variant="body2" color="text.secondary"><strong>PHONE:</strong> {user.phoneNumber}</Typography>
                                        <Typography variant="body2" color="text.secondary"><strong>DESIGNATION:</strong> {user.designation}</Typography>
                                        <Typography variant="body2" color="text.secondary"><strong>INSTITUTE:</strong> {user.institute}</Typography>
                                        <Typography variant="body2" color="text.secondary"><strong>CATEGORY:</strong> {user?.category ? user?.category : "Indian_Delegate"}</Typography>
                                        <Typography variant="body2" color="text.secondary"><strong>FOOD PERFERENCE:</strong> {user.foodCategory}</Typography>
                                    </Box>
                                </Box>
                                <Divider sx={{ marginY: 3 }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}><Typography><strong>Address:</strong> {user.address}</Typography></Grid>
                                    <Grid item xs={12} sm={6}><Typography><strong>City:</strong> {user.city}</Typography></Grid>
                                    <Grid item xs={12} sm={6}><Typography><strong>State:</strong> {user.state}</Typography></Grid>
                                    <Grid item xs={12} sm={6}><Typography><strong>Country:</strong> {user.country || 'India'}</Typography></Grid>
                                    <Grid item xs={12} sm={6}><Typography><strong>Pincode:</strong> {user.pincode}</Typography></Grid>
                                    <Grid item xs={12} sm={6}><Typography><strong>Registration Category:</strong> {user.registrationCategory?.regiCategoryName}</Typography></Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        {user.additionalPeople?.length > 0 && (
                            <Card sx={{ marginBottom: 4, borderRadius: 3 }}>
                                <CardContent>
                                    <Typography variant="h6" fontWeight="bold" marginBottom={2}>Accompanying Persons</Typography>
                                    <AptaTable
                                        columns={['Name', 'Gender', 'Food Preference', 'User ID', 'Status', 'Payment Status']}
                                        rows={user.additionalPeople?.map((person) => ({
                                            "Name": person.name,
                                            "Gender": person.gender,
                                            "Food Preference": person.foodCategory,
                                            "User ID": person.userId,
                                            "Status":
                                                <MDTypography variant="caption" fontWeight="bold" color={person.paymentStatus === "paid" ? "success" : "error"}>
                                                    {person.paymentStatus}
                                                </MDTypography>,
                                            "Payment Status": (
                                                <Switch
                                                    checked={person.paymentStatus === "paid"}
                                                    onChange={() => handlePaymentToggle(person, person.paymentStatus === "paid")}
                                                    color="success"
                                                />
                                            )
                                        }))}
                                    />
                                </CardContent>
                            </Card>
                        )}
                        <Card sx={{ borderRadius: 3, marginBottom: 4 }}>
                            <CardContent>
                                <Typography variant="h6" fontWeight="bold" marginBottom={2}>Payment History</Typography>
                                <AptaTable
                                    columns={['Payment ID', 'Transaction Type', 'Status', 'Amount', 'Date']}
                                    rows={(user.paymentHistory || []).map((payment) => ({
                                        "Payment ID": payment.transactionId,
                                        "Transaction Type": payment.trasactionType,
                                        "Status": payment.status,
                                        "Amount": `₹${payment.amount}`,
                                        "Date": moment(payment.date).format('DD MMM YYYY, hh:mm A')
                                    }))}
                                />
                            </CardContent>
                        </Card>
                    </>
                )}
            </Box>
        </DashboardLayout>
    );
};

export default Dashboard;
